var $ = global.jQuery = global.$;

var _Base = require('./_Base');

/**
 * Widget for select, input and textarea controls
 * @class
 * @extends _Base
 */
var Field = _Base.extend(
  /** @lends Field.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;

    this.$inputs = this.$el.find('input');
    this.$input = this.$inputs.eq(0);
    this.$select = this.$el.find('select').eq(0);
    this.$textarea = this.$el.find('textarea')[0];

    this.suppressEvents = false;
    this.externalSuppressEvents = false;

    this.type = this.$input.attr('type') ? this.$input.attr('type') : 'select';

    this.currentValue = this.getValue();
    this.name = this.getName();

    this.updateField();

    if (this.type === 'select') {
      this.selectOptions = this.getSelectOptions();
    }

    this.$input.on('input change', this._changeHandler.bind(this));
    this.$select.on('change', this._changeHandler.bind(this));

  },
  /**
   * Get the fields current value
   * @returns {string|number|date} The fields current value
   */
  getValue: function() {
    if (this.type === 'radio') {
      return this.getRadioValue();
    } else if (this.type === 'select') {
      return this.$select.val();
    } else {
      return this.$input.val();
    }
  },
  /**
   * Get value if the field is a radio
   * @returns {string} The radio button current value. Or null if nothing selected
   */
  getRadioValue: function() {
    var selectedItem = $('[name=' + this.name + ']:checked');
    if (selectedItem) {
      return selectedItem.value;
    } else {
      return null;
    }
  },
  /**
   * Set field value
   * @param {string|number} value The value to set the field to
   */
  setValue: function(value) {
    if (this.type === 'select') {
      this.$select.val(value);
      this.$select.trigger('change');
    } else {
      this.$input.val(value);
      this.$input.trigger('change');
    }
  },
  /**
   * Set index of selected option (for select elements)
   * @param {number} index The index to set as selected
   */
  setSelectIndex: function(index) {
    if (this.type === 'select') {
      this.$select.get(0)[index].selected = true;
      this.$select.trigger('change');
    }
  },
  /**
   * Replace the options of a select element
   * @param {Object[]} newOpts - An object of properties for each new select option
   * @param {string} newOpts[].Text - The text value of the new select option.
   * @param {string|number} newOpts[].Value - The value of the new select option.
   * @param {bool} [newOpts[].Selected] - Whether or not this option is selected.
   * @param {bool} persist - Whether or not to persist the select at whatever it's value was prior to the change.
   * @param {bool} keepFirstOpt - Whether or not to keep the existing first option. Useful if the firt option is a default eg. 'Please select'.
   */
  updateSelectOptions: function(newOpts, persist, keepFirstOpt) {
    var $selectedOpt = this.$select.find('option:selected');
    var optVal = $selectedOpt.attr('value') ? $selectedOpt.attr('value') : $selectedOpt.text();
    var select = this.$select.get(0);
    var firstOpt = keepFirstOpt ? {
      'Text': this.$select.find('option').eq(0).text(),
      'Value': this.$select.find('option').eq(0).attr('value')
    } : null;

    var opts = firstOpt ? [firstOpt] : [];

    $.each(newOpts, function() {
      opts.push(this);
    });

    this.suppressEvents = true;

    select.length = 0;

    $.each(opts, function(i) {
      select[i] = this.Value ? new Option(this.Text,this.Value) : new Option(this.Text);
    });

    if (persist && optVal) {
      this.setValue(optVal);
    }

    this.suppressEvents = false;

    this.$el.trigger('Select:optionsUpdated', [this.getSelectOptions()]);
  },
  /**
   * Get current options of the select
   * @returns {array} An array representing the current Select options
   */
  getSelectOptions: function() {
    var opts = [];
    var $opts = this.$select.find('option');

    $opts.each(function() {
      var opt = {};
      var selected = $(this).is(':selected');
      opt.Text = $(this).text();
      opt.Value = $(this).attr('value') ? $(this).attr('value') : $(this).text();

      if (selected) opt.Selected = selected;

      opts.push(opt);
    });

    return opts;
  },
  /**
   * @returns {string} The field name attribute
   */
  getName: function() {
    if (this.type === 'select') {
      return this.$select.attr('name');
    } else {
      return this.$input.attr('name');
    }
  },
  /**
   * Handle field changes
   * @private
   */
  _changeHandler: function() {
    if (this.currentValue !== this.getValue()) {
      this.updateField();
    }
  },
  /**
   * Update field and broadcast the Field:updated event
   */
  updateField: function() {
    this.currentValue = this.getValue();
    if (this.type === 'select') this.selectOptions = this.getSelectOptions();

    /**
     * Fires whenever the field value is updated. Caught by any containing Form widget.
     * @event Field:updated
     * @memberof Field
     * @type array
     * @property {string} name The name attribute of the field
     * @property currentValue The current value of the field
     * @property {Object} $input a reference to this.$input
     * @property {int} selectedIndex the selected index if the field is a select
     */
    if (!this.suppressEvents && !this.externalSuppressEvents) this.$el.trigger('Field:updated', [this.name, this.currentValue, this.$input, this.$select.selectedIndex]);
  }
});

module.exports = Field;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/Field.js
 ** module id = 9
 ** module chunks = 0 1
 **/